<template>
	<b-card>
		<div class="hidden-print">
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="false"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="departments"
						v-model="departmentId"
						@select="disableOption"
						class="multiselect-pricing"
						:placeholder="$t('promo-to-product.department')"
					/>
				</b-col>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="true"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						:options="departments"
						v-model="departmentIds"
						:disabled="depDisabled"
						class="multiselect-pricing"
						:placeholder="$t('promo-to-product.department')"
					/>
				</b-col>
				<b-col cols="2" align="center" class="p-1">
					<b style="display: inline-block">Вся фирма:</b>
					<b-checkbox class="ml-2" style="display: inline-block" v-model="allDep" switch/>
				</b-col>
				<b-col cols="1" align="center">
					<b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-3"/>
					<!--<b-button @click="print" variant="outline-dark" class="fa fa-print"/>-->
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<multiselect
						label="name"
						track-by="id"
						:multiple="false"
						v-model="groupId"
						:options="groups"
						:allow-empty="true"
						:group-select="true"
						:show-labels="false"
						class="multiselect-pricing"
						:placeholder="$t('goods.create.select-group')"
					/>
				</b-col>
				<b-col>
					<b-form-input :placeholder="$t('incomes.create.product')" v-model="itemName" type="text"/>
				</b-col>
				<b-col>
					<b-form-input :placeholder="$t('goods.special-barcode')" v-model="barcode" type="text"/>
				</b-col>
				<b-col>
					<b-form-input :placeholder="$t('goods.artikul')" v-model="article" type="text"/>
				</b-col>
			</b-row>
		</div>
		<b-card-body>
			<b-overlay :show="loading" rounded opacity="0.7">
				<table id="gridContainer" class="b-table table-striped table-hover table-bordered" :class="items.length > 0 ? 'table-responsive' : ''" style="width: 100%; height: 70vmin">
					<thead>
					<tr>
						<th style="width: 3% !important; font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">№</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('pos.product') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white; white-space: nowrap" class="text-center">{{ $t('goods.special-barcode') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('goods.artikul') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('goods.barcode') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('kirim.expirationDate') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('incomes.date') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('contragent.group-name') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">{{ $t('incomes.create.price') }}</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white" class="text-center">Oстатка</th>
						<th style="font-size: 11px; position: sticky; top: 0; border: 1px solid #000; outline: 1px solid #000; background-color: white; white-space: nowrap" v-for="dep in depList" class="text-center">{{ dep.name }}</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="(item, index) in items" :key="index">
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">{{ index+1 }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; width: 100% !important; white-space: nowrap">{{ item.itemName }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">{{ item.barcode }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">{{ item.artikul }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">"{{ `${item.multiBarcode}` }}"</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center; white-space: nowrap">{{ item.termOfItem ? item.termOfItem : '' }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center; white-space: nowrap">{{ item.regDate ? item.regDate : '' }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">{{ item.subName }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center; white-space: nowrap">{{ item.priceUzs }} {{item.depCurencyCode}}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center">{{ item.remaining }}</td>
						<td style="padding: 2px 4px; font-size: 11px; border: 1px solid #3b3b3b; text-align: center" v-for="dep in depList">{{ item[dep.name] }}</td>
					</tr>
					</tbody>
				</table>
				<b-button v-if="items.length > 0" class="float-right mt-1" @click="excelExport1('gridContainer', 'Отчет № 5')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
			</b-overlay>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import DxDataGrid, {DxColumn, DxExport, DxColumnChooser, DxFilterRow, DxSearchPanel, DxLoadPanel} from "devextreme-vue/data-grid";
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import ReportService from "./report.service";
import { BOverlay } from 'bootstrap-vue';
import ReferencesService from "../../../services/references.sevice";

export default {
	name: "Index",
	components: {
		Multiselect,
		DxDataGrid,
		DxColumn,
		DxExport,
		DxColumnChooser,
		DxFilterRow,
		DxLoadPanel,
		DxSearchPanel,
		BOverlay
	},
	data() {
		return {
			departmentId: null,
			departmentIds: null,
			depId: null,
			depIds: [],
			groupId: null,
			itemName: '',
			barcode: '',
			article: '',
			groups: [],
			departments: [],
			allDep: false,
			depDisabled: false,
			items: [],
			depList: [],
			position: { of: "#gridContainer" },
			showIndicator: true,
			shading: true,
			showPane: true,
			closeOnOutsideClick: false,
			loading: false,
			json_to_excel: {
				'Продукт': 'itemName',
				'Спец-код': 'barcode',
				'Артикул': 'artikul',
				'Штрих-код': '" '+'multiBarcode'+' "',
				'Срок годности': 'termOfItem',
				'Дата': 'regDate',
				'Название группы': 'subName',
				'Цена': 'priceUzs'+' UZS',
				'Oстатка': 'remaining'
			}
		}
	},
	watch: {
		departmentId: {
			handler(t) {
				if (t)
					this.depId = t.id
				else
					this.depId = null
			}
		},
		departmentIds: {
			handler(t) {
				this.depIds = []
				if (t)
					t.forEach(dep => {
						this.depIds.push(dep.id)
					})
				else
					this.depIds = []
			}
		},
		allDep: {
			handler(t) {
				if (t) {
					this.depIds = []
					if (this.departments.length > 0) {
						this.depDisabled = true
						this.departments.forEach(dep => {
							this.depIds.push(dep.id)
						})
					} else {
						this.$vs.notify({
							title: 'Отделов пока нет !',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						});
					}
				} else {
					this.depDisabled = false
					this.departmentIds = []
					this.departmentId = null
				}
			}
		}
	},
	methods: {
		onContentReady(e) {
			e.component.option("loadPanel.enabled", false);
		},
		getDepartments() {
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getItems() {
			this.loading = true
			let data = {
				fromDepId: this.allDep === false ? this.depId : null,
				toDepIds: this.depIds,
				subCategoryId: this.groupId ? this.groupId.id : null,
				sub2CategoryId: null,
				sub3CategoryId: null,
				value: this.itemName,
				barcode: this.barcode,
				article: this.article
			}
			ReportService.getReportItems_5(data).then(res => {
				if (res.data && res.data.length > 0) {
					this.depList = []
					this.departments.forEach(dep => {
						this.depIds.forEach(d => {
							if (d === dep.id) {
								this.depList.push(dep)
								this.json_to_excel[dep.name] = `${dep.name}`
							}
						})
						if (this.depId === dep.id)
							this.depList.unshift(dep)
					})
					if (this.allDep) {
						this.departmentIds = []
						this.departmentId = null
					}
					this.items = res.data
				} else {
					this.items = []
					this.depList = []
				}
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			})
		},
		print() {
			window.print();
		},
		disableOption(dep) {
			this.departments.forEach(d => {
				d.disabled = d.id === dep.id;
			})
			this.$forceUpdate()
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			var dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		}
	},
	created() {
		ReferencesService.getSubReferenceChildren(14).then(res => {
			this.groups = res.data
		})
		this.getDepartments();
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
	.nav {
		display: none;
	}
	.nav-pills {
		display: none;
	}
	.flex-column {
		display: none;
	}
}
</style>
